import styled, { css } from 'styled-components';
import withMobile from '../hocs/withMobile';

const ContentContainer = styled.div`
  --container-width: 900px;
  ${(props) =>
    props.isMobile &&
    css`
      --container-width: 320px;
    `};

  z-index: 1;
  padding: 0 15px;
  display: flex;
  box-sizing: border-box;
  width: var(--container-width);
  flex-direction: column;
  align-items: center;
`;

// Mobile Container wider than ContentContainer
export const FatBlockContainer = styled.div`
  width: calc(100% + 20px);
  align-self: center;
`;

export default withMobile(ContentContainer);
